import { IDate } from '../appLogic/interfaces/date';
import { IItem } from '../appLogic/interfaces/item';
import { IBom } from '../appLogic/interfaces/bom';
import { IBusiness } from './entities/businessBase';

/**
 *
 */
type ValueOf<T> = T[keyof T];

// TableContentの表示用オブジェクト
/**
 *
 */
type IDisplayObject = IBusiness & IItem & IBom;

/**
 *
 */
type businessMode = 'create' | 'edit' | 'view' | 'delete';
/**
 *
 */
type objectType = 'business' | 'bom' | 'item'; // テーブルで表示するインターフェース一覧
/**
 *
 */
type formOfTransaction = 'buySell' | 'manufacture';
/**
 *
 */
type OrderChartDateUnit = 'day' | 'month';
/**
 *
 */
type businessForecastStatusType = 'orderStatus' | 'supplierForecastStatus';
const tableType = [
  'registration',
  'recommend-order',
  'fix-order',
  'forecast',
  'bom-parent',
  'bom-parts',
  'inventory',
  'trash',
  'calendar',
  // ここからdemo1追加分
  'bom', // BOM
  'organization-business', // 取引一覧（自社の）
  'sales-collection', // 取引情報コレクション
  'receive-cooperation', // 取引合意依頼(受信)
  'rejected-business', // 却下取引
  'unsupported', // 登録済み取引情報（自社）
  'send-cooperation', // 取引合意依頼(送信)
  'receive-forecast', // 受領内示コレクション
  'send-forecast', // 提示内示コレクション
  'default', // 暫定的においているだけ。必要なくなったら消す
  'inventoryControl', //在庫管理
  'inventoryControlWithOrder', //在庫管理(発注モード)
  'baseTable', // テスト用ヘッダーリスト
  'confirmSupplierTable', // 仕入先内示確認
  'supplierTable', // 仕入先内示,
  'simpleBusinessSummary', // 取引概要
  'firmOrderTable', // 確定発注
  'notExportedOrderTable', // 未出力発注
  'progressRateTableByRepPerson', // 担当者別仕入先内示進捗率
  'progressRateTableBySupplier', // 仕入先別仕入先内示進捗率
  'forecastForReceiptStaffFilterTable', // 客先内示担当者フィルターテーブル
  'forecastForReceiptAllBusinessTable', // 受領内示取引テーブル
  'forecastForReceiptSearchResultTable', // 受領内示検索結果テーブル,
  'customerForecastDiffLastMonth', // 内示前月差異
  'unmanagedBusinessTypeAnnounce', // 未管理取引（内示）
  'unmanagedBusinessTypeSalesResult', // 未管理取引（販売実績）
  'unmanagedBusinessTypeInventory', // 未管理取引（在庫）
  'unmanagedBusinessTypeArrival', // 未管理取引（入荷）
  'unmanagedBusinessTypeModal', // 未管理取引（モーダル）
  'unmanagedBusinessTypeModalWhenAggregateRow', // 未管理取引（集計行モーダル）
  'supplierForecastAllBusinessTable', // 仕入先内示の全取引テーブル
  'orderManageTable', // 発注管理画面
  'deletionBusinessTable', // 削除取引テーブル
  'moveWarehouse', // 置き場移動テーブル
  'moveWarehouseWithChoice', // 置き場移動テーブル（選択列付き）
  'editAggregateBusinessChild', // 集計編集の子取引一覧モーダル
  'orderCalendar', // 発注カレンダー
  'forecastAccuracyTable', // 内示正答率テーブル
  'unmatchedOrder',
  'inventoryDashboardStock', //ダッシュボード
  'inventoryDashboardForecastAccuracy',
  'inventoryDashboardAlert',
  'inventoryDashboardByDimensionTurnover',
  'inventoryDashboardByDimensionEndInventory',
  'inventoryDashboardByDimensionArrival',
  'inventoryDashboardByDimensionOrderAmount',
  'inventoryDashboardByDimensionSupplierForecast',
  'inventoryDashboardByDimensionSalesResult',
  'inventoryDashboardByDimensionCustomerForecast',
  'inventoryDashboardByDimensionForecastAccuracy',
  'bulkEditAggregateBusiness',
  'bulkEditBaseBusiness',
  'editMasterAggregateBusiness',
  'editMasterBaseBusiness',
] as const;
/**
 *
 */
type TableType = (typeof tableType)[number];

/**
 * 与えられた文字列がTableTypeかを判定する
 * @param value - 判定する文字列
 */
export const isTableType = (value: string): value is TableType => {
  const validateSet = new Set<string>(tableType);
  return validateSet.has(value);
};

const headerModifiableTableType = [
  'trash',
  'deletionBusinessTable',
  'firmOrderTable',
  'forecastForReceiptAllBusinessTable',
  'customerForecastDiffLastMonth',
  'notExportedOrderTable',
  'orderManageTable',
  'supplierForecastAllBusinessTable',
  'unmanagedBusinessTypeAnnounce',
  'unmanagedBusinessTypeArrival',
  'unmanagedBusinessTypeInventory',
  'unmanagedBusinessTypeSalesResult',
] as const;

/**
 * ヘッダーを編集可能なテーブルタイプ
 */
type HeaderModifiableTableType = Extract<TableType, (typeof headerModifiableTableType)[number]>;

/**
 * 与えられたテーブルタイプが編集可能か(HeaderModifiableTableTypeにキャスト可能か)を判別する関数
 * @param tableType - テーブルタイプ
 * @returns - テーブルタイプ(編集可能)
 */
export const isHeaderModifiableTableType = (tableType: TableType): tableType is HeaderModifiableTableType => {
  return headerModifiableTableType.some((t) => t === tableType);
};

/**
 *
 */
type ChartDay = IDate;

/**
 *
 */
interface ActiveDate {
  date: string;
  className?: string;
}

/**
 * NOTE: ここの定義を appLogic/view/preferences.ts/TableContentSchema 内で
 * Zodで書き換えて手写ししています。
 * どちらかの定義を変更する際はもう一方の定義も変更してください
 */
interface TableProperty {
  customFormulaTitle?: string;
  customFormula?: string[];
  customFormulaId?: number;
}

/**
 *
 */
interface TableLabel {
  label: string;
  data: string;
}

/**
 *
 */
interface InputOption {
  [key: string]: number[];
}

/**
 *
 */
interface ConfirmContext {
  alertInfos: AlertInfo[];
  extraInfos: AlertInfo[];
  status: boolean;
}

/**
 *
 */
interface AlertInfo {
  month: number;
  threshould: number;
  bound: string;
}

/**
 *
 */
interface ValidateRule {
  require?: boolean;
  min?: number;
  max?: number;
  minLabel?: string;
  maxLabel?: string;
  func?(key?: string, value?: any): [boolean, string]; // 検査対象 -> 真偽値,出力文字 //　真偽値は正常な場合はtrueを返す
}

/**
 *
 */
interface ValidateRequire extends ValidateRule {
  require: boolean;
}

/**
 *
 */
interface ValidateLimitMin extends ValidateRule {
  min: number;
  minLabel: string;
}

/**
 *
 */
interface ValidateLimitMax extends ValidateRule {
  max: number;
  minLabel: string;
}

/**
 *
 */
interface ValidateFunction extends ValidateRule {
  func(key?: string, value?: any): [boolean, string];
}

/**
 *
 */
type ValidateLimit = ValidateLimitMin & ValidateLimitMax;

/**
 *
 */
interface ValidateRules {
  [key: string]: ValidateRule;
}

/**
 *
 */
interface ISelectOption {
  label: string;
  value: string | number;
}

/**
 *
 */
interface ISelectFormDataSet {
  [x: string]: any;
  displayData?: number;
  selectedUnit: ISelectOption['value'];
}

/**
 *
 */
interface FixOrderValue {
  deliveryDate: IDate;
  leadTime: number;
  orderAmount: number;
  defineOrderNumber: number;
}
/**
 * 共通のテーブル表示型
 */
const extraTableColumn = ['expansion', 'choice', 'edit'] as const;
/**
 *
 */
type TableHeader<T = never> = Partial<Readonly<{ [k in keyof IBusiness | (typeof extraTableColumn)[number] | keyof T]: string }>>;
export type {
  IDisplayObject,
  objectType,
  businessForecastStatusType,
  businessMode,
  ISelectOption,
  TableType,
  formOfTransaction,
  ChartDay,
  OrderChartDateUnit,
  ISelectFormDataSet,
  ActiveDate,
  TableProperty,
  TableLabel,
  InputOption,
  ConfirmContext,
  AlertInfo,
  FixOrderValue,
  ValidateRule,
  ValidateRequire,
  ValidateLimitMin,
  ValidateLimitMax,
  ValidateFunction,
  ValidateRules,
  TableHeader,
  HeaderModifiableTableType,
};

/**
 * IBusinessのネストしていないプロパティのキー
 */
export type CommonTableHeaderKey =
  | 'expansion'
  | 'choice'
  | 'businessId'
  | 'aggregateBusinessId'
  | 'warehouseNumber'
  | 'warehouse'
  | 'supplierNumber'
  | 'supplierName'
  | 'businessNumber'
  | 'businessName'
  | 'package'
  | 'unit'
  | 'manufacturer'
  | 'customerNumber'
  | 'customerName'
  | 'salesDestinationNumber'
  | 'salesDestinationName'
  | 'endUser'
  | 'headerModify'
  | 'businessUpdateAt'
  | 'choiceBusinessId'
  | 'supplierForecastResponsibleUser'
  | 'customerForecastResponsibleUser'
  | 'purchaseUnitPrice'
  | 'salesUnitPrice'
  | BusinessFreeColumnTableHeaderKey;

/**
 * 集計取引自由欄の動的テーブルヘッダーキー
 */
export type BusinessFreeColumnTableHeaderKey = `businessFreeColumnValues-aggregate-${number}`;

/**
 * テーブルのヘッダーのキーがCommonTableHeaderKeyかどうか
 * @param key - テーブルのヘッダーのキー
 */
export const isCommonTableHeaderKey = (key: string): key is CommonTableHeaderKey => {
  return (
    [
      'expansion',
      'choice',
      'businessId',
      'aggregateBusinessId',
      'warehouseNumber',
      'warehouse',
      'supplierNumber',
      'supplierName',
      'businessNumber',
      'businessName',
      'package',
      'unit',
      'manufacturer',
      'customerNumber',
      'customerName',
      'salesDestinationNumber',
      'salesDestinationName',
      'endUser',
      'headerModify',
      'businessUpdateAt',
      'choiceBusinessId',
      'supplierForecastResponsibleUser',
      'customerForecastResponsibleUser',
      'purchaseUnitPrice',
      'salesUnitPrice',
    ].includes(key) || /^businessFreeColumnValues-aggregate-\d+$/.test(key)
  );
};

/**
 * テーブルのヘッダーリスト
 */
export type HeaderList = {
  key: string;
  text: string;
  isShown: boolean;
}[];

/**
 * 初期表示時デフォルトで非表示にしているヘッダーリスト
 */
const DefaultDisableHeaderList = [
  'warehouseNumber',
  'supplierNumber',
  'unit',
  'customerNumber',
  'salesDestinationNumber',
  'deliveryDestinationNumber',
  'leadTime',
  'stdInventoryIndex',
  'MOQ',
  'supplierForecastResponsibleUser',
  'customerForecastResponsibleUser',
  'TrashBinWarehouseNumber',
  'TrashBinSupplierNumber',
  'TrashBinUnit',
  'TrashBinCustomerNumber',
  'TrashBinDeliveryDestinationNumber',
  'TrashBinSupplierForecastResponsibleUser',
  'TrashBinCustomerForecastResponsibleUser',
  'OrderControlWarehouseNumber',
  'OrderControlSupplierNumber',
  'OrderControlUnit',
  'OrderControlAggregateBusinessResponsibleUsers',
] as const;
/**
 * 初期表示時デフォルトで非表示にしているヘッダーリストのタイプ
 */
type DefaultDisableHeaderList = (typeof DefaultDisableHeaderList)[number];

/**
 * 渡されたキーがデフォルトで非表示のヘッダーに含まれるか
 * @param key - ヘッダーキー
 */
export const isDefaultDisableHeaderList = (key: string): key is DefaultDisableHeaderList => {
  return DefaultDisableHeaderList.some((header) => header === key);
};

/**
 * 渡された文字列が有効なTableTypeかどうかを判別する関数
 * @param type - テーブルの種類
 * @returns - テーブルの種類が有効かどうか
 */
export const isValidTableType = (type: string): type is TableType => {
  return tableType.includes(type as TableType);
};

export { extraTableColumn, tableType };
